import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useAuth from '../../hooks/useAuth';
import { apiSlice } from '../../app/api/apiSlice';
import { selectCurrentCustomerId, setCurrentCustomerId } from './taxContextSlice';

const customerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTaxCustomers: builder.query({ query: () => '/taxpayers/customer-options' }),
  }),
});

export default function CustomerContextSelector() {
  const { isGlobalAdmin } = useAuth();
  const dispatch = useDispatch();
  const selected = useSelector(selectCurrentCustomerId);
  const { data: customers = [], isFetching, error } = customerApi.useGetTaxCustomersQuery(undefined, { skip: !isGlobalAdmin });
  if (!isGlobalAdmin) return null;
  return <div className="mb-4 w-full max-w-md">
    <label htmlFor="tax-customer" className="mb-1 block text-sm font-medium text-slate-700">Customer</label>
    <select id="tax-customer" value={selected ?? ''} disabled={isFetching || Boolean(error)}
      onChange={(event) => dispatch(setCurrentCustomerId(event.target.value))}
      className="w-full rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm">
      <option value="">{isFetching ? 'Memuat customer...' : 'Pilih customer'}</option>
      {customers.map((customer) => <option key={customer.customer_id} value={customer.customer_id}>{customer.customer_name}</option>)}
    </select>
    {error && <p role="alert" className="mt-2 text-sm text-red-700">{error?.data?.message || 'Gagal memuat customer.'}</p>}
    {!isFetching && !error && !selected && <p className="mt-2 text-sm text-slate-500">Pilih customer untuk memuat data wajib pajak.</p>}
  </div>;
}
